// @ts-ignore
__webpack_public_path__ = process.env.REACT_APP_PUBLIC_PATH || '/';
